import { Phone } from "lucide-react";
import { PHONE_HREF } from "../lib/site";

export const StickyCall = () => (
  <a
    href={PHONE_HREF}
    className="lg:hidden fixed bottom-0 left-0 right-0 z-40 flex items-center justify-center gap-2 bg-[#d90429] text-white py-4 font-semibold text-base shadow-[0_-4px_20px_rgba(0,0,0,0.15)] active:bg-[#ef233c]"
    data-testid="sticky-call-btn"
  >
    <Phone className="w-5 h-5" /> Call Now — Get Your Passport Fast
  </a>
);
